import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";

import styled from "styled-components";

const ButtonWrapper = styled.button`
  color: #004576;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 5em;
  border: none;
  background-color: transparent;
  align-items: center;
`;

const BackButton = ({ backLogo }) => {
  const goBack = () => {
    window.history.go(-1);
  };

  return backLogo ? (
    <ButtonWrapper onClick={goBack}>
      <FontAwesomeIcon icon={faAngleLeft} /> <span>Back</span>
    </ButtonWrapper>
  ) : (
    <ButtonWrapper onClick={goBack}>Back</ButtonWrapper>
  );
};

export default BackButton;
